module.exports = __webpack_public_path__ + "static/media/visa_brand.e0ebaf2c.png";